// API helper functions for cart operations
async function makeCartAPICall(endpoint, data = null, method = 'GET') {
  const url = `/api/shopify/${endpoint}`;

  const options = {
    method,
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json'
    }
  };

  if (data && method !== 'GET') {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      errorData.error ||
        `HTTP error! status: ${response.status} ${response.statusText} for ${method} ${url}`
    );
    error.status = response.status;
    throw error;
  }

  return response.json();
}

// Recognizes the "Access denied" bot-detection response returned by the
// safeCheckBotId() check in the /api/shopify/* cart routes.
export function isBotDeniedError(error) {
  return error?.status === 403 && error?.message === 'Access denied';
}

// API wrapper functions
export async function addToCartAPI(checkoutId, lines) {
  return makeCartAPICall('addToCart', { checkoutId, lines }, 'POST');
}

export async function removeFromCartAPI(checkoutId, lineIds) {
  return makeCartAPICall('removeFromCart', { checkoutId, lineIds }, 'POST');
}

export async function updateCartAPI(checkoutId, lines) {
  return makeCartAPICall('updateCart', { checkoutId, lines }, 'POST');
}

export async function getCartAPI() {
  return makeCartAPICall('getCart', {}, 'POST');
}

// `lines` is optional so a cart can be created "empty" (legacy fallback path)
// or pre-populated in a single round-trip when adding to cart for the first
// time (see cart-context.js), avoiding a separate create-then-add sequence.
export async function createCartAPI(lines) {
  return makeCartAPICall('createCart', lines ? { lines } : {}, 'POST');
}
